import React,{useCallback,useId,useState} from 'react';
import Cropper from 'react-easy-crop';
import {useCareerLanguage} from './CareerLanguage';
export default function CareerPhotoCrop({src,disabled,onArea,onAdjust}){
 const {t}=useCareerLanguage(),id=useId(),[crop,setCrop]=useState({x:0,y:0}),[zoom,setZoom]=useState(1);
 const complete=useCallback((_,pixels)=>onArea(pixels),[onArea]);
 const move=value=>{if(!disabled){setCrop(value);onAdjust();}};
 const zoomTo=value=>{if(!disabled){setZoom(value);onAdjust();}};
 return <div className={'cw-photo-crop'+(disabled?' is-busy':'')} aria-busy={disabled}>
  <p id={id+'-help'}>{t('photoCropHelp')}</p>
  <div className="cw-photo-crop-frame" aria-describedby={id+'-help'}><Cropper image={src} imageAltText={t('photo')} crop={crop} zoom={zoom} aspect={1} minZoom={1} maxZoom={4} zoomWithScroll={false} onCropChange={move} onZoomChange={zoomTo} onCropComplete={complete}/></div>
  <label htmlFor={id+'-zoom'}>{t('photoZoom')}<input id={id+'-zoom'} type="range" min="1" max="4" step="0.05" value={zoom} disabled={disabled} onChange={e=>zoomTo(Number(e.target.value))}/></label>
 </div>;
}
